/** Laid out and not collapsed away: a 0×0 box is as good as missing. */
export const isVisible = (el: Element): boolean => {
  const r = el.getBoundingClientRect();
  return r.width > 0 || r.height > 0;
};

const query = (target: string): HTMLElement | null => {
  // Tour targets are our own constants (dots, slashes, dashes): no quotes to escape.
  const all = document.querySelectorAll<HTMLElement>(`[data-tour="${target}"]`);
  return Array.from(all).find(isVisible) ?? null;
};

/**
 * Looks for `[data-tour=target]`, polling while lazy routes and data load.
 * Polling (not a MutationObserver) because visibility can change through
 * layout alone, with no DOM mutation to observe.
 */
export const findTarget = (
  target: string,
  { timeoutMs = 2000, intervalMs = 100 }: { timeoutMs?: number; intervalMs?: number } = {},
): { promise: Promise<HTMLElement | null>; cancel: () => void } => {
  let cancel = () => {};
  const promise = new Promise<HTMLElement | null>((resolve) => {
    const found = query(target);
    if (found) return resolve(found);
    const started = Date.now();
    const timer = setInterval(() => {
      const el = query(target);
      if (el) {
        clearInterval(timer);
        resolve(el);
      } else if (Date.now() - started >= timeoutMs) {
        clearInterval(timer);
        resolve(null);
      }
    }, intervalMs);
    cancel = () => {
      clearInterval(timer);
      resolve(null);
    };
  });
  return { promise, cancel };
};
